import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";

export default {
  name: "ContactCategory",
  components: {
    TableList
  },
  data() {
    return {
      permissionIsAuthorize: 'ContactCategory',
      modalTitle: "Nova Categoria de Contato",
      countFilter: 0,
      itemList: [],
      filter: {
        Id: null,
        Name: null,
        IsExcluded: false
      },
      idField: 0,
      itemGet: {
        Id: null,
        Name: null
      },
      itemAdd: {
        Name: null
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFieldForm: false
    };
  },
  mounted() {
    this.ListContactCategory();
  },
  methods: {
    OpenMAction(e, id, view){
      e.preventDefault();
      this.ResetItemGet();
      // Update
      if (view == undefined && id != undefined) {
        this.pOpened = id;
        this.idField = id;
        this.isSeeing = false;
        this.modalTitle = "Editar campo";
        this.GetContactCategory(id);
      }
      // Add new
      else if (view == undefined && id == undefined) {
        this.modalTitle = "Nova Categoria de Contato";
        this.pOpened = null;
        this.isSeeing = false;
        
      }
      // View
      else {
        this.pOpened = null;
        this.idField = id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.GetContactCategory(id);
      }

      this.$bvModal.show("mFormAction");
    },
    OpenMAdd(e){
      e.preventDefault();
      this.modalTitle = "Nova Categoria de Contato";
      this.ResetItemGet();
      this.$bvModal.show("mFormAdd");
    },
    
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListContactCategory();
    },

    ResetFilter() {
      this.filter = {
        Id: null,
        Name: null,
        IsExcluded: false
      };
      this.ListContactCategory();
    },

    ResetItemGet() {
      this.itemGet = {
        Id: null,
        Name: null
      };
      this.itemAdd = {
        Name: null
      }
      this.idField = 0;
      this.isSeeing = false;
      this.loading = false;
      this.pOpened = null;
    },

    SaveField() {
      this.validatedFieldForm = true;
      this.$refs.FieldValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AddContactCategory();
          } else {
            // Update
            this.UpdateContactCategory();
            this.ListContactCategory();
            this.$bvModal.hide("mFormAction");
          }
        }
      });
    },

    AddContactCategory() {
      this.loading = true;
      this.$store
        .dispatch("AddContactCategory", this.itemAdd)
        .then(() => {
          this.$makeToast("O campo foi cadastrado com sucesso.","success","Campo cadastrado");
          this.ListContactCategory();
          this.$bvModal.hide("mFormAdd");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao criar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    UpdateContactCategory() {
      this.itemGet.Id = this.idField;
      this.$store.dispatch("UpdateContactCategory", this.itemGet)
        .then(() => {
          this.$makeToast("O Campo foi atualizado com sucesso.","success","Campo atualizado");
          this.ListContactCategory();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Erro ao atualizar campo, tente novamente.","danger","Erro ao atualizar campo",error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    GetContactCategory(id) {
        this.loading = true;
        this.$store.dispatch("GetContactCategory", { id: id })
          .then(response => {
            this.itemGet = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo","danger","Erro ao carregar o campo",error);
          })
          .finally(() => {
            this.loading = false;
          });
      
    },

    ListContactCategory() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Name": this.filter.Name,
        "Object.IsExcluded": this.filter.IsExcluded
      };
      delete data.TotalItems;
      this.$store.dispatch("ListContactCategory", data)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
                          "danger","Erro ao listar os Campos",error);
        })
        .finally(() => (this.loading = false));
    },

    DeleteContactCategory(id) {
      this.$store.dispatch("DeleteContactCategory", { id: id })
        .then(() => {
          this.$makeToast("O Campo foi removido com sucesso.","success","Campo removido");
          this.ListContactCategory();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.","danger","Erro ao remover Campo",error);
        });
    },

    ConfirmDeleteContactCategory(e, item, view) {
      console.log(item.Name);
      this.$makeMsgBox("Você tem certeza que deseja remover " + item.Name + " ?",
                       "Confirmar",this.DeleteContactCategory, item.Id);
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/ContactCategory/ContactCategory.js